import React from 'react';
import { convertVideoLinks } from '../../utils/video';
import { formatDate } from '../../utils/date';

interface PostCardProps {
  id: string;
  title: string;
  date: string;
  content: string;
}

export default function PostCard({ id, title, date, content }: PostCardProps) {
  const contentWithVideos = convertVideoLinks(content);

  const formattedDate = formatDate(date);

  return (
    <div
      id={id}
      className="bg-gray-100 dark:bg-gray-800 text-gray-800 dark:text-gray-200 p-6 rounded-lg shadow mb-6"
    >
      <h3 className="text-2xl font-semibold mb-1">{title}</h3>
      <p className="text-sm text-gray-500 dark:text-gray-400 mb-4">
        {formattedDate}
      </p>
      <div
        className="prose dark:prose-invert max-w-none text-justify"
        dangerouslySetInnerHTML={{ __html: contentWithVideos }}
      />
    </div>
  );
}
